<template>
    <!-- Heading and compose button are the parent's responsibility (the
         Flights-style section header in Experience.vue). -->
    <div class="announcements-rail" v-if="posts.length">

        <!-- Full post cards: replies, votes and reactions happen right here,
             because these posts are deliberately NOT repeated in the feed. -->
        <post-card
            v-for="post in posts"
            :key="post.id"
            :post="post"
            :reg-id="regId"
            :is-staff="isStaff"
            class="rail-card"
            @changed="$emit('changed')"
        />
    </div>
</template>

<script>
    import PostCard from './PostCard.vue';

    export default {
        name: 'AnnouncementsRail',
        components: {PostCard},
        props: {
            posts: {type: Array, required: true},
            regId: {type: Number, required: true},
            isStaff: {type: Boolean, default: false}
        }
    };
</script>

<style lang="scss" scoped>
    .announcements-rail {
        .rail-card {
            border-left: 4px solid #628b21;
        }
    }
</style>
